// extracted by mini-css-extract-plugin
export default {"main":"styles_main__X8aMi","head":"styles_head__rPT5Z","textoCard":"styles_textoCard__3GTYw","sectionConteudo":"styles_sectionConteudo__VfKc-"};